
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';

export default Vue.extend({
  components: { Icon },
  props: {
    iconName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    actionButtonLabel: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleButtonClick() {
      this.$emit('onButtonClick');
    },
  },
});
